



























































































import Vue from 'vue';
import store from '@/store';
import { PacketInfoOption, WorkflowStep } from '@/store/getStarted';

import { WebRequestStatus } from '@/models';
import { BasePacket, BasePacketKind, Badge } from '@/models/packet';

import CogsDefinition from '@/components/widgets/CogsDefinition.vue';
import GetStartedNav from '@/components/getStarted/GetStartedNav.vue';
import GetStartedNavNextButton from '@/components/getStarted/GetStartedNavNextButton.vue';
import MultiPointPacketEditor from '@/components/MultiPointPacketEditor.vue';
import PacketCard from '@/components/PacketCard.vue';
import SinglePointPacketEditor from '@/components/SinglePointPacketEditor.vue';

export default Vue.extend({
  components: {
    CogsDefinition,
    GetStartedNav,
    GetStartedNavNextButton,
    MultiPointPacketEditor,
    PacketCard,
    SinglePointPacketEditor
  },

  props: {
    isPacketDetailsOpen: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      packetDetails: null as null | BasePacket,
      badgesDetails: null as null | Badge[]
    };
  },

  computed: {
    packetOptions(): PacketInfoOption[] {
      return store.state.getStarted.publicPacketOptions;
    },

    selectedOptions(): PacketInfoOption[] {
      return this.packetOptions.filter(([, , selected]) => selected);
    },

    noneSelected(): boolean {
      return this.selectedOptions.length == 0;
    },

    isDetailsSingle(): boolean {
      return this.packetDetails?.kind === BasePacketKind.SINGLE_POINT;
    },

    isDetailsMulti(): boolean {
      return this.packetDetails?.kind === BasePacketKind.MULTI_POINT;
    },

    hasDetails(): boolean {
      return !!this.packetDetails;
    },

    statusedBadgesDetails(): [Badge, WebRequestStatus.READY][] {
      return (this.badgesDetails || []).map(b => [b, WebRequestStatus.READY]);
    },

    errors(): string[] {
      return this.noneSelected
        ? ['* Please select at least one set of COGS']
        : [];
    }
  },

  methods: {
    loadPublicPackets() {
      store.dispatch.getStarted.getPublicPackets();
    },

    togglePacket(packet: BasePacket) {
      store.dispatch.getStarted.togglePacket(packet);
    },

    showPacketDetails(packet: BasePacket, badges: Badge[]) {
      this.packetDetails = packet;
      this.badgesDetails = badges;
      this.$router.push({
        query: { isPacketDetailsOpen: `${true}` }
      });
    },

    hidePacketDetails() {
      this.$router.go(-1);
    },

    finish() {
      store.dispatch.getStarted.goToStep(WorkflowStep.REVIEW);
    }
  },

  mounted() {
    this.loadPublicPackets();
  }
});
